import _get from 'lodash/get';
import { AnswerEntityInterface } from '@types';

export const convertToRows = (rows) => {
  return rows.map((item) => convertToRow(item));
};

const getAnswerType = (answer) => {
  return _get(answer, 'questionnaire.title');
};

export const convertToRow = (answer: AnswerEntityInterface) => {
  const nameProperty = 'fullNameEng';
  const { createdAt, id, status } = answer;

  return {
    id,
    respondent: answer.owner[nameProperty],
    hr: answer.owner.responsibleHrManager ? answer.owner?.responsibleHrManager[nameProperty] : '',
    group: answer.owner.unit?.name,
    createdAt: createdAt.toString().slice(0, 10),
    editedBy: answer.editedBy ? answer.editedBy[nameProperty] : '',
    status,
    original: answer,
    type: getAnswerType(answer),
  };
};

export const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};
